import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Background from '../widgets/splash/Background';
import Header from '../widgets/header/Header';
import Footer from '../widgets/footer/Footer';
import Splash from '../widgets/splash/Splash';
import ScrollToTop from './ScrollToTop';

import StoreFront from './../store/home/StoreFront';
import Shop from './../store/home/Shop';
import ShopByBrands from '../store/brands/ShopByBrands';
import Categories from './../store/categories/Categories';
import ShopByCollections from './../store/collections/ShopByCollections';
import ViewSale from './../store/dashboard/sales/ViewSale';
import PaymentStatus from './../store/cart/PaymentStatus';
import Checkout from '../store/cart/Checkout';
import CheckoutSuccess from '../store/cart/CheckoutSuccess';
import Register from '../store/auth/Register';
import RegisterSuccess from '../store/auth/RegisterSuccess';
import Cart from '../store/cart/Cart';
import ViewStoreProduct from '../store/products/ViewStoreProduct';


const Login = React.lazy(() => import('../store/auth/Login'));
const AdminLogin = React.lazy(() => import('../store/auth/AdminLogin'));
const DashboardLayout = React.lazy(() => import('./../store/dashboard/DashboardLayout'));
const Dashboard = React.lazy(() => import('./../store/dashboard/Dashboard'));
const ManageBrands = React.lazy(() => import('../store/dashboard/brands/ManageBrands'));
const ManageCategories = React.lazy(() => import('../store/dashboard/categories/ManageCategories'));
const ViewCategory = React.lazy(() => import('../store/dashboard/categories/ViewCategory'));
const Settings = React.lazy(() => import('../store/dashboard/settings/Settings'));
const ManageUsers = React.lazy(() => import('../store/dashboard/users/ManageUsers'));
const ProductSettings = React.lazy(() => import('../store/dashboard/products/ProductSettings'));
const CreateProduct = React.lazy(() => import('../store/dashboard/products/manageProducts/CreateProduct'));
const EditProduct = React.lazy(() => import('../store/dashboard/products/manageProducts/EditProduct'));
const ViewProduct = React.lazy(() => import('../store/dashboard/products/manageProducts/ViewProduct'));
const ManageCollections = React.lazy(() => import('../store/dashboard/collections/ManageCollections'));
const ViewCollection = React.lazy(() => import('../store/dashboard/collections/ViewCollection'));
const AddCollection = React.lazy(() => import('../store/dashboard/collections/AddCollection'));
const Sales = React.lazy(() => import('../store/dashboard/sales/Sales'));
const Account = React.lazy(() => import('../store/dashboard/account/Account'));
const Logout = React.lazy(() => import('../store/dashboard/users/Logout'));
const AppRouter = () => {
    const showSplash = useSelector((state) => state.app.showSplash);
    const userLoggedStatus = useSelector((state) => state.app.isuserlogged);
    return (
        <>
            {
                showSplash &&
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route index element={<Splash />} />
                        <Route path='/admin/login' element={<AdminLogin />} />
                        <Route path="*" element={<Splash />} />
                    </Routes>
                </BrowserRouter>
            }
            {
                (!showSplash) &&
                <BrowserRouter>
                    <ScrollToTop />
                    <Background />
                    <div id='storeFront'>
                        <Header />
                        <div id='storeFrontContent'>
                            <Routes>
                                <Route index element={<StoreFront />} />
                                <Route path='/shop' element={<Shop />} />
                                <Route path='/shop/:type/:id/:name' element={<Shop />} />
                                <Route path='/shop/:name' element={<Shop />} />
                                <Route path='/shop/search/:query' element={<Shop />} />
                                <Route path='/brands' element={<ShopByBrands />} />
                                <Route path='/categories' element={<Categories />} />
                                <Route path='/collections' element={<ShopByCollections />} />
                                <Route path="/shop/products/:sku" element={<ViewStoreProduct />} />
                                <Route path="/shop/products/var/:sku" element={<ViewStoreProduct />} />
                                <Route path='/cart' element={<Cart />} />
                                <Route path='/checkout' element={<Checkout />} />
                                <Route path='/checkout/success' element={<CheckoutSuccess />} />
                                <Route path='/payment/status' element={<PaymentStatus />} />
                                
                                <Route path='/login' element={<Login />} />
                                <Route path='/register' element={<Register />} />
                                <Route path='/register/success' element={<RegisterSuccess />} />

                                <Route path='/dashboard' element={<DashboardLayout />} >
                                    <Route index element={<Dashboard />} />
                                    <Route path="account" element={<Account />} />
                                    <Route path="brands" element={<ManageBrands />} />
                                    <Route path="categories" element={<ManageCategories />} />
                                    <Route path="categories/view" element={<ViewCategory />} />
                                    <Route path="products" element={<ProductSettings />} />
                                    <Route path="products/create" element={<CreateProduct />} />
                                    <Route path="products/edit" element={<EditProduct />} />
                                    <Route path="products/view" element={<ViewProduct />} />
                                    <Route path="collections" element={<ManageCollections />} />
                                    <Route path="collections/create" element={<AddCollection />} />
                                    <Route path="collections/view" element={<ViewCollection />} />
                                    <Route path="sales" element={<Sales />} />
                                    <Route path="sales/view/:id" element={<ViewSale />} />

                                    <Route path="settings" element={<Settings />} />
                                    <Route path="users" element={<ManageUsers />} />

                                    {/* <Route path="*" element={<Products />} /> */}
                                </Route>

                                <Route path='/dashboard/logout' element={<Logout />} />

                            </Routes>
                        </div>
                        <Footer />
                    </div>
                </BrowserRouter>
            }
        </>



    );
}
export default AppRouter;